import { Link } from "react-router-dom";
import { SiteLayout } from "../components/layout/SiteLayout";
import { SeoHead } from "../components/seo/SeoHead";

const EDITIONS = [
  {
    id: "starter",
    name: "Starter",
    target: "TPE, < 25 utilisateurs",
    features: [
      "Fonctions essentielles",
      "Support email",
      "1 organisation",
      "Mises à jour incluses",
    ],
  },
  {
    id: "professional",
    name: "Professional",
    target: "PME, 25–250 utilisateurs",
    features: [
      "Toutes fonctions Starter",
      "Intégrations API",
      "Support prioritaire",
      "Multi-sites",
      "Création d'environnement en ligne",
    ],
    highlight: true,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    target: "Grand compte",
    features: [
      "Toutes fonctions Professional",
      "SSO / SAML",
      "SLA dédié",
      "Déploiement sur mesure",
      "Account manager",
    ],
  },
];

export function PricingEditionsPage() {
  return (
    <SiteLayout>
      <SeoHead
        title="Comparer les éditions"
        description="Starter, Professional, Enterprise — choisissez l'édition ITaaS adaptée à votre organisation en RDC et Afrique."
        canonicalPath="/pricing/editions"
      />
      <div className="pep-page-hero py-5 mb-0">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb pep-breadcrumb mb-3">
              <li className="breadcrumb-item">
                <Link to="/pricing">Tarifs</Link>
              </li>
              <li className="breadcrumb-item active">Éditions</li>
            </ol>
          </nav>
          <h1 className="display-5 fw-bold mb-2">Comparer les éditions</h1>
          <p className="lead mb-0 opacity-90">Trois niveaux pour chaque module — de la TPE au grand compte.</p>
        </div>
      </div>
      <div className="container py-5">
        <div className="row g-4 mb-5">
          {EDITIONS.map((ed) => (
            <div className="col-md-4" key={ed.id}>
              <div
                className={`card h-100 border-0 shadow-sm ${ed.highlight ? "pep-edition-highlight" : ""}`}
              >
                <div className="card-body p-4">
                  {ed.highlight && (
                    <span className="badge text-bg-primary mb-2">Recommandé</span>
                  )}
                  <h2 className="h4 fw-bold">{ed.name}</h2>
                  <p className="text-secondary small">{ed.target}</p>
                  <ul className="list-unstyled small mb-4">
                    {ed.features.map((f) => (
                      <li className="mb-2" key={f}>
                        <span className="text-success me-1">✓</span>
                        {f}
                      </li>
                    ))}
                  </ul>
                  <Link className="btn btn-outline-primary w-100" to="/pricing">
                    Voir les tarifs
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <Link className="btn btn-primary btn-lg me-2" to="/configure">
            Créer mon environnement
          </Link>
          <Link className="btn btn-outline-primary btn-lg" to="/configure">
            Demander un devis
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}
